module.exports = __webpack_public_path__ + "img/student_report_03.21f3e5ee.png";